import { Avatar } from "@ui/Avatar";
import {
	type AccountsReferrer,
	touchAccountsReferrer,
} from "@ui/layouts/AccountLayout/accountsReferrer";
import "./MenuFooter.css";

type Props = {
	src?: string | null;
	name: string;
	referrer: AccountsReferrer;
};

export const MenuFooterAvatar = (props: Props) => (
	<a
		href="/account"
		class="menu-footer-avatar"
		aria-label="Account settings"
		onClick={() => touchAccountsReferrer(props.referrer)}
	>
		<Avatar src={props.src ?? undefined} alt={props.name} size="small" />
	</a>
);
